import React from "react";
import PdfContext from "../../../PdfContext";
import ContactDetails from "../../sharedComponents/ContactDetails";

const FromContactDetails = () => (
  <PdfContext.Consumer>
    {({ colorPalette, fromContactDetails }) => (
      <ContactDetails
        contactDetails={fromContactDetails}
        label="Prepared by:"
        textColor="#333333"
        labelColor={colorPalette.secondary}
        labelHasBorder={true}
      />
    )}
  </PdfContext.Consumer>
);

export default FromContactDetails;
